// Small formatting helpers for the members' pages (WI12).

export const when = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString([], { dateStyle: "short", timeStyle: "short" }) : "";

export const day = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleDateString([], { dateStyle: "medium" }) : "");

// Amounts are kept in the currency's smallest unit (paise, cents).
export const money = (minor: number, currency: string) =>
  `${currency} ${(minor / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const toMinor = (value: string) => Math.round(Number(value.replace(/[^\d.]/g, "")) * 100);

export const phone = (digits: string | null | undefined) => (digits ? `+${digits}` : "");

export const lines = (value: unknown) => (Array.isArray(value) ? value.join("\n") : "");

export const split = (value: string) =>
  value
    .split(/\n/)
    .map((v) => v.trim())
    .filter(Boolean);

export const PACKS: Record<string, string> = { full: "Full membership", lite: "Lite" };
export const STATUSES = ["member", "lead", "paused", "left"];
export const ROLES = ["payer", "father", "mother", "grandparent", "sibling", "staff", "other"];
export const CONSENT_KINDS: Record<string, string> = {
  agent: "Niro as agent",
  pass_through: "Pass-through costs",
  parent_data: "Parent's consent comes first",
  parent_own: "Parent's own consent",
};
